import React from 'react';
import { UnreachableCaseError } from 'ts-essentials';
import { ChartMode } from '../types';
import CompactChartHeader from './CompactChartHeader';
import BuildChartHeader from './BuildChartHeader';
import ViewChartHeader from './ViewChartHeader';
import { useChartContext } from '../ChartContext';

const ChartHeader = () => {
  const {
    metadata: { mode },
  } = useChartContext();

  switch (mode) {
    case ChartMode.View:
      return <ViewChartHeader />;
    case ChartMode.Build:
      return <BuildChartHeader />;
    case ChartMode.Compact:
      return <CompactChartHeader />;
    default:
      throw new UnreachableCaseError(mode);
  }
};

export default ChartHeader;
